import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";

export default class GHGEmissionService {

  static getTemplateFile() {
    return HttpUtil.getExcelData(
      API_ROUTES.GHG_EMISSION.GET_TEMPLATE
    );
  }

  static uploadTemplate(formData, companyId, entityId, standardId) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.UPLOAD_TEMP
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId)
      .replace("<standardId>", standardId), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static getDataCol(
    companyId,
    entityId,
    pageNumber = 0,
    pageSize = DEFAULT_ITEMS_PER_PAGE,
    status,
    standardId
  ) {
    return HttpUtil.get(
      API_ROUTES.GHG_EMISSION.GET_DATA_COLLECTION
        .replace("<companyId>", companyId)
        .replace("<entityId>", entityId)
        .replace("<pageNumber>", pageNumber)
        .replace("<pageSize>", pageSize)
        .replace("<status>", status)
        .replace("<standardId>", standardId)
    );
  }

  static getFatorsList(
    db,
    pageNumber = 0,
    pageSize = DEFAULT_ITEMS_PER_PAGE,
    searchKey
  ) {
    return HttpUtil.get(
      API_ROUTES.GHG_EMISSION.GET_FACTORS
        .replace("<db>", db)
        .replace("<pageNumber>", pageNumber)
        .replace("<pageSize>", pageSize)
        .replace("<key>", searchKey)
    );
  }

  static saveCollectionData(data, db, companyId, entityId, finalizeStatus, standardId) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.SAVE_COL_DATA
      .replace("<db>", db)
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId)
      .replace("<finalizeStatus>", finalizeStatus)
      .replace("<standardId>", standardId), data);
  }

  static getDBInfo() {
    return HttpUtil.get(
      API_ROUTES.GHG_EMISSION.GET_DB_INFO);
  }

  static checkImport(companyId) {
    return HttpUtil.get(
      API_ROUTES.GHG_EMISSION.CHECK_IMPORT
        .replace("<companyId>", companyId)
    );
  }

  static finalizeCollectionData(companyId, entityId, standardId) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.FINALIZE_COL_DATA
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId)
      .replace("<standardId>", standardId), {});
  }

  static editCollectionItem(data, db, companyId, entityId, standardId) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.EDIT_COL_ITEM
      .replace("<db>", db)
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId)
      .replace("<standardId>", standardId), data);
  }

  static mapCategoryWithAI(db, companyId, entityId, jobId) {
    return HttpUtil.postForReportAI(API_ROUTES.GHG_EMISSION.AI_MAP_CATEGORY
      .replace("<db>", db)
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId)
      .replace("<jobId>", jobId));
  }

  static categoryWithAIStatus(companyId, entityId, jobId) {
    return HttpUtil.getFromReportAI(API_ROUTES.GHG_EMISSION.AI_MAP_CATEGORY_STATUS
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId)
      .replace("<jobId>", jobId));
  }

  static mapSelectedCategoryWithAI(data, db, companyId, entityId, jobId) {
    return HttpUtil.postForReportAI(API_ROUTES.GHG_EMISSION.AI_SELECTED_MAP_CATEGORY
      .replace("<db>", db)
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId)
      .replace("<jobId>", jobId), data);
  }

  static createJobIdForAI(companyId, entityId) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.CREATE_JOB_ID
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId), {});
  }

  static getJobIdForAI(companyId, entityId) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.CREATE_JOB_ID
      .replace("<companyId>", companyId)
      .replace("<entityId>", entityId));
  }

  static saveOrgBoundaries(companyId, period, data) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.SAVE_ORG_BOUNDARIES
      .replace("<companyId>", companyId)
      .replace("<period>", period), data);
  }

  static getOrgBoundaries(companyId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_ORG_BOUNDARIES
      .replace("<companyId>", companyId)
      .replace("<period>", period));
  }

  static getScopesDataSet(companyId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_SCOPES_DATA
      .replace("<companyId>", companyId)
      .replace("<period>", period)
    );
  }

  static getScopeandCategories() {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_SCOPES);
  }

  static getMatScopeCategory(standardId) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_MAT_SCOPE_CAT
      .replace("<standardId>", standardId)
    );
  }

  static saveOprBoundaries(period, companyId, data) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.SAVE_OPR_BOUNDARIES
      .replace("<period>", period)
      .replace("<companyId>", companyId), data);
  }

  static getDataSet(companyId) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_DATA_SET
      .replace("<companyId>", companyId));
  }

  static getEmissionSourcesData(dataset, companyId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_EMISSION_SOURCES
      .replace("<companyId>", companyId)
      .replace("<period>", period)
      .replace("<dataset>", dataset));
  }

  static saveEmissionSources(dataset, companyId, period, data) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.SAVE_EMISSION_SOURCES
      .replace("<companyId>", companyId)
      .replace("<period>", period)
      .replace("<dataset>", dataset), data);
  }

  static getSummaryData(dataset, companyId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_SUMMARY
      .replace("<companyId>", companyId)
      .replace("<period>", period)
      .replace("<dataset>", dataset));
  }

  static getSummaryAll(companyId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_SUMMARY_ALL
      .replace("<companyId>", companyId)
      .replace("<period>", period));
  }

  static finalizeGHGInventory(companyId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.FINALIZE_GHG_INV
      .replace("<companyId>", companyId)
      .replace("<period>", period));
  }

  static getGHGMetricsByFilter(stdId, filter) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_GHG_METRIC_DATA
        .replace("<standardId>", stdId)
        .replace("<scope>", filter.scope)
        .replace(
          filter.category ? '<category>' : '&category=<category>',
          filter.category ? filter.category : ''
        )
        .replace(
          filter.businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&businessUnitIds=<businessUnitIds>",
          filter.businessUnitIds?.length > 0 ? filter.businessUnitIds?.toString() : ''
        )
        .replace(
          filter.periodFrom ? '<periodFrom>' : '&periodFrom=<periodFrom>',
          filter.periodFrom ? filter.periodFrom : ''
        )
        .replace(
          filter.periodTo ? '<periodTo>' : '&periodTo=<periodTo>',
          filter.periodTo ? filter.periodTo : ''
        )
    );
  }

  static getGHGDatapointsByMetric(stdId, mId, filter) {
    let url = API_ROUTES.STANDARDS.GET_GHG_DATAPOINTS
      .replace("<standardId>", stdId)
      .replace("<metricId>", mId)
    let appended = false;
    if (filter.businessUnitIds?.length > 0) {
      url += `?businessUnitIds=${filter.businessUnitIds?.toString()}`;
      appended = true;
    }
    if (filter.periodFrom) {
      if (appended) {
        url += `&`;
      } else {
        url += `?`;
      }
      url += `periodFrom=${filter.periodFrom}`;
      appended = true;
    }
    if (filter.periodTo) {
      if (appended) {
        url += `&`;
      } else {
        url += `?`;
      }
      url += `periodTo=${filter.periodTo}`;
      appended = true;
    }
    return HttpUtil.get(url);
  }

  static getEmissionSummary(standardId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_EMISSION_SUMMARY
      .replace("<standardId>", standardId)
      .replace("<period>", period));
  }

  static getEmissionByPeriod(standardId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_BY_PERIOD
      .replace("<standardId>", standardId)
      .replace("<period>", period));
  }

  static getEmissionByGHGType(standardId, period) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_BY_GHG_TYPE
      .replace("<standardId>", standardId)
      .replace("<period>", period));
  }
  //29323
 
   static saveMetricEmissionLinking(standardId,metricId,payload) {
    console.log("payload",payload)
    console.log("metricId",metricId)
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.ADD_METRIC_EMISSION_LINKING
      .replace("<standardId>", standardId)
      .replace("<metricId>", metricId),payload);
          
  }

   static getEmissionSources(emissiontable,scope, category){
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_EMISSION_SOURCE
      .replace("<emissiontable>", emissiontable)
      .replace("<scope>", scope)
      .replace("<category>", category));
          
  }

  static getMetricEmissionLinking(standardId, metricId) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_METRIC_EMISSION_LINKING
      .replace("<standardId>", standardId)
      .replace("<metricId>", metricId));
  }   

  static saveDatapointEmissionLinking(standardId, datapointId, payload) {
    return HttpUtil.post(API_ROUTES.GHG_EMISSION.ADD_DATAPOINT_EMISSION_LINKING
      .replace("<standardId>", standardId)
      .replace("<datapointId>", datapointId), payload);
  }

  static getDatapointEmissionLinking(standardId, datapointId) {
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_DATAPOINT_EMISSION_LINKING
      .replace("<standardId>", standardId)
      .replace("<datapointId>", datapointId));
  }

  static deleteMetricEmissionLinking(standardId, metricId) {
    return HttpUtil.delete(API_ROUTES.GHG_EMISSION.DELETE_METRIC_EMISSION_LINKING
      .replace("<standardId>", standardId)
      .replace("<metricId>", metricId));
  } 

  static deleteDatapointEmissionLinking(standardId, datapointId) {
    return HttpUtil.delete(API_ROUTES.GHG_EMISSION.DELETE_DATAPOINT_EMISSION_LINKING
      .replace("<standardId>", standardId)
      .replace("<datapointId>", datapointId));
    }

  static getDVData(standardId, filter) {
    if (!filter) return Promise.reject(new Error('Filter is required'));
    const businessUnitIdsParam = Array.isArray(filter.businessUnitIds)
      ? filter.businessUnitIds.join(',')
      : (filter.businessUnitIds ?? '');
    return HttpUtil.get(API_ROUTES.GHG_EMISSION.GET_DV_DATA
      .replace("<standardId>", standardId)
      .replace("<scope>", Array.isArray(filter.scope) ? filter.scope.join(',') : (filter.scope ?? ''))
      .replace(
        filter.category ? '<category>' : '&category=<category>',
        Array.isArray(filter.category) ? filter.category.join(',') : (filter.category ?? '')
      )
      .replace("<businessUnitIds>", businessUnitIdsParam)
      .replace(
        filter.periodFrom ? '<periodFrom>' : '&periodFrom=<periodFrom>',
        filter.periodFrom ? filter.periodFrom : ''
      )
      .replace(
        filter.periodTo ? '<periodTo>' : '&periodTo=<periodTo>',
        filter.periodTo ? filter.periodTo : ''
      )
    );
  }

  static getVersionScopeDetails(versionId, db) {
    return HttpUtil.get(
      API_ROUTES.EMISSION_FACTOR_LINK.GET_VERSION_SCOPE_DETAILS
        .replace("<versionId>", versionId)
        .replace("<db>", db)
    );
  }
}